import { isPlatform } from '@ionic/core';
import { find, get } from 'lodash';

const deviceInfo = {
  ios: [
    {
      type: 'ios-se',
      width: 320,
      height: 568,
    },
    {
      type: 'ios-8',
      width: 375,
      height: 667,
    },
    {
      type: 'ios-8-plus',
      width: 414,
      height: 736,
    },
    {
      type: 'ios-11Pro',
      width: 375,
      height: 812,
    },
    {
      type: 'ios-11-max',
      width: 414,
      height: 896,
    },
  ],
};

export const getDevice = () => {
  const { innerWidth, innerHeight } = window;
  if (isPlatform('ios')) {
    return get(
      find(
        deviceInfo.ios,
        obj => obj.width === innerWidth && obj.height === innerHeight,
      ),
      'type',
      'ios-generic',
    );
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/util/helpers-ionic.js